import(/* webpackMode: "eager" */ "/codebuild/output/src487489695/src/frontend/apps/researchers/src/components/pages/PaperEditPage.tsx")